<template>
  <div class="roster-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <b-col cols="12">
              <div class="pull-right">
                <b-input-group v-bind:prepend="$t('report.date_range')">
                  <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                </b-input-group>
              </div>
              <div class="pull-right" style="margin: 0 0.5em;" v-show="checkShowByConfig('export_hourly_sales_report_csv')">
                <vue-json-to-csv :json-data="reportData"
                  :labels="(clientSg) ? reportDataTitleSG: reportDataTitle"
                  :csv-title="'hourly_sale_report'"
                  >
                  <button class="btn btn-danger">Export CSV</button>
                </vue-json-to-csv>
              </div>
            </b-col>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card header-tag="header" class="mt-2" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('side_bar.hourly_sale_report') }}</strong>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">
                          <span>{{$t('report.time')}}</span>
                        </th>
                        <th scope="col">
                          <span>{{$t('report.cash')}}</span>
                        </th>
                        <th scope="col" v-if="clientSg">
                          <span>{{$t('report.dbs')}}</span>
                        </th>
                        <th v-else scope="col">
                          <span>{{$t('report.swipe')}}</span>
                        </th>
                        <th scope="col" v-if="clientSg">
                          <span>{{$t('report.dbs-on-tile')}}</span>
                        </th>
                        <th scope="col" v-if="clientSg">
                          <span>{{$t('report.amex')}}</span>
                        </th>
                        <th scope="col">
                          <span>{{$t('report.credit_card')}}</span>
                        </th>
                        <th scope="col" v-show="checkShowByConfig('gcash')">
                          <span>{{$t('report.gcash')}}</span>
                        </th>
                        <th scope="col" v-show="checkShowByConfig('paymaya')">
                          <span>{{$t('report.paymaya')}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="data.length == 0">
                        <td class="text-center" colspan="4">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="(item, index) in data" :key="index + 0">
                        <td scope="row" class="text-left">
                          {{item.time}}
                        </td>
                        <td scope="row" class="text-left">
                          {{item.sales.cash}}
                        </td>
                        <td v-if="clientSg" scope="row" class="text-left">
                          {{item.sales.dbs}}
                        </td>
                        <td v-else scope="row" class="text-left">
                          {{item.sales.eftpos}}
                        </td>
                        <td v-if="clientSg" scope="row" class="text-left">
                          {{item.sales.dbsOnTile}}
                        </td>
                        <td v-if="clientSg" scope="row" class="text-left">
                          {{item.sales.amex}}
                        </td>
                        <td scope="row" class="text-left">
                          {{item.sales.credit_card}}
                        </td>
                        <td scope="row" class="text-left" v-show="checkShowByConfig('gcash')">
                          {{item.sales.gcash}}
                        </td>
                        <td scope="row" class="text-left" v-show="checkShowByConfig('paymaya')">
                          {{item.sales.paymaya}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
            </b-col>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card header-tag="header" class="mt-2" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('report.hourly_transaction_report') }}</strong>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                      <th scope="col">
                        <span>{{$t('report.time')}}</span>
                      </th>
                      <th scope="col">
                        <span>{{$t('report.cash')}}</span>
                      </th>
                      <th scope="col" v-if="clientSg">
                        <span>{{$t('report.dbs')}}</span>
                      </th>
                      <th v-else scope="col">
                        <span>{{$t('report.swipe')}}</span>
                      </th>
                      <th scope="col" v-if="clientSg">
                        <span>{{$t('report.dbs-on-tile')}}</span>
                      </th>
                      <th scope="col" v-if="clientSg">
                        <span>{{$t('report.amex')}}</span>
                      </th>
                      <th scope="col">
                        <span>{{$t('report.credit_card')}}</span>
                      </th>
                      <th scope="col" v-show="checkShowByConfig('gcash')">
                        <span>{{$t('report.gcash')}}</span>
                      </th>
                      <th scope="col" v-show="checkShowByConfig('paymaya')">
                        <span>{{$t('report.paymaya')}}</span>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="data.length == 0">
                      <td class="text-center" colspan="4">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="(item, index) in data" :key="index + 0">
                      <td scope="row" class="text-left">
                        {{item.time}}
                      </td>
                      <td scope="row" class="text-left">
                        {{item.transactions.cash}}
                      </td>
                      <td v-if="clientSg" scope="row" class="text-left">
                        {{item.transactions.dbs}}
                      </td>
                      <td v-else scope="row" class="text-left">
                        {{item.transactions.eftpos}}
                      </td>
                      <td v-if="clientSg" scope="row" class="text-left">
                        {{item.transactions.dbsOnTile}}
                      </td>
                      <td v-if="clientSg" scope="row" class="text-left">
                        {{item.transactions.amex}}
                      </td>
                      <td scope="row" class="text-left">
                        {{item.transactions.credit_card}}
                      </td>
                      <td scope="row" class="text-left" v-show="checkShowByConfig('gcash')">
                        {{item.transactions.gcash}}
                      </td>
                      <td scope="row" class="text-left" v-show="checkShowByConfig('paymaya')">
                        {{item.transactions.paymaya}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import Vue from 'vue'
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  name: 'HourlySaleReportList',
  components: {
    DataTable,
    DateRangePicker
  },
  data: function () {
    return {
      filter: {
        startAt: this.$moment().format('YYYY-MM-DD'),
        endAt: this.$moment().format('YYYY-MM-DD')
      },
      data: [],
      report: this.$store.getters.config.gms.report,
      reportData: [],
      reportDataTitle: {
          HourlySaleCategory: { title: 'Hourly Sale Report' },
          HSRTime: { title: 'Time' },
          HSRCash: { title: 'Cash' },
          HSRSwipe: { title: 'Swipe' },
          HSRCreditCard: { title: 'Credit Card' },
          Separator1: { title: '' },
          HourlyTransactionCategory: { title: 'Hourly Transaction Report' },
          HTCTime: { title: 'Time' },
          HTCCash: { title: 'Cash' },
          HTCSwipe: { title: 'Swipe' },
          HTCCreditCard: { title: 'Credit Card' },
      },
      clientSg: false,
      clientPh: false,
      reportDataTitleSG: {
        HourlySaleCategory: { title: 'Hourly Sale Report' },
          HSRTime: { title: 'Time' },
          HSRCash: { title: 'Cash' },
          HSRDBS: { title: 'DBS! Paylah' },
          HSRDBSOnTile: { title: 'DBS Paylah! On Tile'},
          HSRAmex: { title: 'AMEX'},
          HSRCreditCard: { title: 'Credit Card' },
          Separator1: { title: '' },
          HourlyTransactionCategory: { title: 'Hourly Transaction Report' },
          HTCTime: { title: 'Time' },
          HTCCash: { title: 'Cash' },
          HTCDBS: { title: 'DBS! Paylah' },
          HTCDBSOnTile: { title: 'DBS Paylah! On Tile'},
          HTCAmex: { title: 'AMEX'},
          HTCCreditCard: { title: 'Credit Card' },
      }
    }
  },
  methods: {
    compileReportData(hourlySaleData, hourlyTransactionData) {
      this.reportData = []
      if (hourlySaleData && hourlyTransactionData) {
        for (let i = 0; i < hourlySaleData.length; i++) {
          if(this.clientSg) {
            this.reportData.push({
              HourlySaleCategory: '',
              HSRTime: hourlySaleData[i].time,
              HSRCash: hourlySaleData[i].cash,
              HSRDBS: hourlySaleData[i].dbs,
              HSRDBSOnTile: hourlySaleData[i].dbsOnTile,
              HSRAmex: hourlySaleData[i].amex,
              HSRCreditCard: hourlySaleData[i].credit_card,
              Separator1: '',
              HourlyTransactionCategory: '',
              HTCTime: hourlyTransactionData[i].time,
              HTCCash: hourlyTransactionData[i].cash,
              HTCDBS: hourlyTransactionData[i].dbs,
              HTCDBSOnTile: hourlyTransactionData[i].dbsOnTile,
              HTCAmex: hourlyTransactionData[i].amex,
              HTCCreditCard: hourlyTransactionData[i].credit_card,
            })
          } else {
            this.reportData.push({
              HourlySaleCategory: '',
              HSRTime: hourlySaleData[i].time,
              HSRCash: hourlySaleData[i].cash,
              HSRSwipe: hourlySaleData[i].eftpos,
              HSRCreditCard: hourlySaleData[i].credit_card,
              Separator1: '',
              HourlyTransactionCategory: '',
              HTCTime: hourlyTransactionData[i].time,
              HTCCash: hourlyTransactionData[i].cash,
              HTCSwipe: hourlyTransactionData[i].eftpos,
              HTCCreditCard: hourlyTransactionData[i].credit_card,
            })
          }
        }
      }
    },
    checkShowByConfig (key) {
        if (this.report == null) {
          return false
        }
        let config = this._.find(this.report.list, function (o) {
          return o.type === key
        })
        if (config == null) {
          return false
        }
        return config.show
      },
    listTransactionSale () {
      let vm = this
      if (this.clientPh) {
        vm.axios.report.getTransactionSaleReportV2('?start=' + this.$moment(this.filter.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss') + '&end=' + this.$moment(this.filter.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss'), function (response) {
          let data = response.data ? response.data.data : []
          if (data) {
            vm.data = data
            vm.compileReportData(data.map(x => ({ time: x.time, ...x.sales })), data.map(x => ({ time: x.time, ...x.transactions })))
          }
        })
      } else {
        vm.axios.report.getTransactionSaleReport('?start=' + this.$moment(this.filter.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss') + '&end=' + this.$moment(this.filter.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss'), function (response) {
          let data = response.data
          if (data) {
            vm.data = data
            vm.compileReportData(data.map(x => ({ time: x.time, ...x.sales })), data.map(x => ({ time: x.time, ...x.transactions })))
          }
        })
      }
    },
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.listTransactionSale()
    }
  },
  created: function () {
    this.clientSg = (localStorage.getItem('clientID') === this.client_uuid.sg) ? true : false;
    this.clientPh = (localStorage.getItem('clientID') === this.client_uuid.ph) ? true : false;
    this.listTransactionSale();
  },
  computed: {
    date_locale: function () {
      let format = this.format_date_range_locale()
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges: function () {
      return this.format_date_ranges()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/report/HourlySaleReport.vue